// extracted by css-extract-rspack-plugin
export default {"aiMarkdown":"xJSRw","smartLink":"yk1Fp","smartLinkInner":"jQ011","icon":"LoRM7"};